export default "__VITE_ASSET__DcJ_1OxZ__"